export const fallbackLanguageCode = 'en'

export const defaultCurrency = 'VND'

export const currencies = [
  {
    name: 'VND',
    value: 'VND',
    localeString: 'vi-VI',
  },
  {
    name: 'THB',
    value: 'B',
    localeString: 'th-TH',
  },
  {
    name: 'JPY',
    value: '¥',
    localeString: 'ja-JP',
  },
]

export const currencyNames = {
  VND: 'VND',
  THB: 'THB',
  JPY: 'JPY',
}

export const loadingStates = {
  idle: 'idle',
  pending: 'pending',
  success: 'success',
  error: 'error',
}

/** các hình thức thanh toán của nhà hàng
 * (hiện tại only apply payment online)
 * thanh toán sau khi ăn
 * thanh toán trước nhận đồ sau
 */
export const paymentTypes = {
  pay_after_receive: 'pay_after_receive',
  pay_in_advance: 'pay_in_advance',
}
